// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for bed mapping info with encounter and patient data.
 * @see #/components/schemas/DevicesBedInfo - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface DevicesBedInfo {
    /**
     * Bed id
     * @dataFormat uuid
     */
    bed_id: string;
    readonly encounter_id: string;
    readonly patient_id: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for DevicesBedInfo
 */
export namespace DevicesBedInfo {
    /**
     * DevicesBedInfo Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Bed id
         * @dataFormat uuid
         */
        bedId: string;
        readonly encounterId: string;
        readonly patientId: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * DevicesBedInfo DTO
     * Transforms DevicesBedInfo model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend DevicesBedInfo model */
        static toModel(obj: DevicesBedInfo): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend DevicesBedInfo model */
        static toApi(obj: Model): DevicesBedInfo {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as DevicesBedInfo;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
